import React, { useEffect, useState } from "react";
import { CgSpinner } from "react-icons/cg";
import { CiEdit } from "react-icons/ci";
import { MdDeleteOutline } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import FeesPayable from "./FeesPayable";
import MuqeemTable from "./MuqeemTable";
import LoadingWithLable from "../../../../../../ReusableComponents/Loading/LoadingWithLable";
import { axios } from "../../../../../../Global";
import { setAppError, setBreadCrumb } from "../../../../../../store/userSlice";
import { useNavigate } from "react-router-dom";
import ESPNew from "./AddNew/ESPNewRow";


const CostPlusAddNew = ({selectDatas,quotationId,updateCostSheetForm}) => {
  const token = localStorage.getItem("token");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { breadCrumbs } = useSelector((state) => state.user);
  const [submitLoading,setSubmitLoading] = useState(false);
  const [FINAL_BODY,SET_FINAL_BODY] = useState([]);

  useEffect(() => {
    // Check if the "EDIT COST SHEET" breadcrumb is already in the array
    const isEditCostSheetInBreadcrumbs = breadCrumbs.some(
      crumb => crumb.label === 'ADD NEW COST SHEET'
    );
  
    if (!isEditCostSheetInBreadcrumbs) {
      dispatch(setBreadCrumb([
        ...breadCrumbs,
        { label: 'ADD NEW COST SHEET', link: `` },
      ]));
    }
  }, [location.pathname,selectDatas,quotationId]);

  const handleSubmit = (e) =>{
    setSubmitLoading(true)
    e.preventDefault();
    const body = FINAL_BODY;
    axios.put(`/dashboard/quotation-cost-sheet-module-add-new/${quotationId}`, body, {
        headers: { Authorization: `Bearer ${token}` },
      }).then((res)=>{
        dispatch(
          setAppError({
            msg: res?.data?.message || "Successfully created.",
            color: "success",
          })
        );
        navigate(`/dashboard/quotation/${quotationId}`, {
          state: { method: "View", quotationId: quotationId },
        });
      }).catch((err) => {
        dispatch(
          setAppError({
            msg: err.message,
          })
        );
      })
      .finally(() => {
        setSubmitLoading(false);
      });
  }

  return (
    <form onSubmit={handleSubmit}>
      <ESPNew
        selectDatas={selectDatas} 
        SET_FINAL_BODY={SET_FINAL_BODY}
        />
      <button type="submit"
          className="bg-red disabled:bg-rose-400 rounded-md p-2 px-4 w-full max-w-xs text-white absolute left-1/2 mt-10 cursor-pointer text-sm"
          disabled={submitLoading}
      >
        {submitLoading ? (
          <LoadingWithLable className={"!mt-0 text-white "} />
        ) : (
          `SUBMIT`
        )}
      </button>
    </form>

  )
}

export default CostPlusAddNew